import {LEGAL_SCRIPT_AUTHOR, UN_FULL_FILL_STATUS, ARCHIVE_STATUS} from '~/contants/base';
import cloneDeep from 'lodash/cloneDeep';

export const getList = (state) => {
  const deepData = cloneDeep(state.list);

  return deepData.map(proposal => {
    const {mst_proposal} = proposal;
    let author = LEGAL_SCRIPT_AUTHOR;

    try {
      if (!mst_proposal.created_by_ls) {
        author = mst_proposal.author?.profile?.full_name;
      }
    } catch (e) {
      author = null;
    }

    return {
      ...proposal,
      author
    }
  })
};

export const getListInMonth = state => {
  const deepData = cloneDeep(state.listInMonth);

  return deepData.map(proposal => {
    const {mst_proposal} = proposal;
    let author = LEGAL_SCRIPT_AUTHOR;

    try {
      if (!mst_proposal.created_by_ls) {
        author = mst_proposal.author?.full_name;
      }
    } catch (e) {
      author = null;
    }

    return {
      ...proposal,
      author
    }
  })
}

export const getComments = (state) => state.comments;

export const getProposal = (state) => state.proposal;

export const getStatus = (state) => state.status;

export const proposalStatusChangeList = (state) => {
  const statusList = state.status;

  return Object.keys(statusList)
    .filter(value => {
      return [UN_FULL_FILL_STATUS, ARCHIVE_STATUS].includes(parseInt(value))
    })
    .reduce((acc, cur) => {
      acc[cur] = statusList[cur];

      return acc;
    }, {})
}

export const proposalStatusFilterList = (state) => {
  const statusList = state.status;

  return Object.keys(statusList)
    .filter(value => {
      return [UN_FULL_FILL_STATUS].includes(parseInt(value))
    })
    .reduce((acc, cur) => {
      acc[cur] = statusList[cur];

      return acc;
    }, {})
}

export const getCurrentStatus = (state) => state.currentStatus;

export const getEmployeeList = (state) => state.employeeList;

export const proposalDeadlineInMonth = state => {
  return state.proposalsDeadlineInMonth.filter(proposal => !proposal.is_todo)
}

export const todoDeadlineInMonth = state => {
  return state.proposalsDeadlineInMonth.filter(proposal => proposal.is_todo)
}